import { eLayoutType } from '@abp/ng.core';
// abpOAuthGuard, not authGuard: the one exported by @abp/ng.core is a stub that logs
// "You should add @abp/ng-oauth packages" and returns false, which cancels the navigation and
// leaves the route unmounted. The real guard lives in @abp/ng.oauth and waits for the token to be
// restored before sending the user to login.
import { abpOAuthGuard } from '@abp/ng.oauth';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { sessionHealthGuard } from './guards/session-health.guard';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () => import('./trainings/trainings.module').then(m => m.TrainingsModule),
    // Guarded like every other route: without it the trainings list mounted and issued its GET
    // before the session existed, so the first requests after a redirect went out unauthenticated.
    // sessionHealthGuard delegates to abpOAuthGuard and additionally stops an endless login loop.
    canActivate: [sessionHealthGuard],
    data:{
      requiredPolicy: 'TrainingTracking.Trainings'
    }
  },
  {
    path: 'session-error',
    pathMatch: 'full',
    loadComponent: () =>
      import('./session-error/session-error.component').then(m => m.SessionErrorComponent),
    data: {
      layout: eLayoutType.empty
    }
  },
  {
    path: 'units',
    pathMatch: 'full',
    loadChildren: () => import('./units/units.module').then(m => m.UnitsModule),
    canActivate: [abpOAuthGuard],
    data:{
      requiredPolicy: 'TrainingTracking.Unit'
    }
  },
  {
    path: 'topics',
    pathMatch: 'full',
    loadChildren: () => import('./topics/topics.module').then(m => m.TopicsModule),
    canActivate: [abpOAuthGuard],
    data:{
      requiredPolicy: 'TrainingTracking.Topic'
    }
  },
  {
    path: 'areas',
    pathMatch: 'full',
    loadChildren: () => import('./areas/areas.module').then(m => m.AreasModule),
    canActivate: [abpOAuthGuard],
    data:{
      requiredPolicy: 'TrainingTracking.Area'
    }
  },
  {

    path: 'training-template',
    pathMatch: 'full',
    loadChildren: () => import('./training-template/training-template.module').then(m => m.TrainingTemplateModule),
    canActivate: [abpOAuthGuard],
    data:{
      requiredPolicy: 'TrainingTracking.TrainingTemplate'
    }
  },
  {

    path: 'reports',
    pathMatch: 'full',
    loadChildren: () => import('./reports/reports.module').then(m => m.ReportsModule),
    canActivate: [abpOAuthGuard],
    data:{
      requiredPolicy: 'TrainingTracking.Reporte'
    }
  },

  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [abpOAuthGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('@volo/abp.ng.account/public').then(m => m.AccountPublicModule.forLazy()),
  },
  {
    path: 'gdpr',
    loadChildren: () => import('@volo/abp.ng.gdpr').then(m => m.GdprModule.forLazy()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(m => m.IdentityModule.forLazy()),
  },
  {
    path: 'language-management',
    loadChildren: () =>
      import('@volo/abp.ng.language-management').then(m => m.LanguageManagementModule.forLazy()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(m => m.SaasModule.forLazy()),
  },
  {
    path: 'chat',
    loadChildren: () => import('@volo/abp.ng.chat').then(m => m.ChatModule.forLazy()),
  },
  {
    path: 'audit-logs',
    loadChildren: () =>
      import('@volo/abp.ng.audit-logging').then(m => m.AuditLoggingModule.forLazy()),
  },
  {
    path: 'openiddict',
    loadChildren: () =>
      import('@volo/abp.ng.openiddictpro').then(m => m.OpeniddictproModule.forLazy()),
  },
  {
    path: 'text-template-management',
    loadChildren: () =>
      import('@volo/abp.ng.text-template-management').then(m =>
        m.TextTemplateManagementModule.forLazy()
      ),
  },
  {
    path: 'file-management',
    loadChildren: () => import('@volo/abp.ng.file-management').then(m => m.FileManagementModule.forLazy()),
  },
  {
  path: 'gdpr-cookie-consent',
    loadChildren: () =>
      import('./gdpr-cookie-consent/gdpr-cookie-consent.module').then(
      m => m.GdprCookieConsentModule
    ),
  },
  {
    path: 'setting-management',
    loadChildren: () =>
      import('@abp/ng.setting-management').then(m => m.SettingManagementModule.forLazy()),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
